import axios from "axios";
// import respuestasFalsas from "../views/registro/RespuestasFalsas"

const setHeaders = () => {
  const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiI1ZWQ2Njc4ODI0YTdiODJlZDBmMGUyYmYiLCJpYXQiOjE2MjIxNDcwNzQsImV4cCI6MTYyMzM1NjY3NH0.mOUxxJmLQ55VsQEiCFe0hYOTe5ZYWro3J3fp2egc_WU';
  return {
    headers: token ? { 'Authorization': `Bearer ${token}` } : {}
  };
};

export const getContrato = (dni) => {
  return axios
    .get("https://prestadores-back.mascota24.com.ar/socios/dniapp/" + dni, setHeaders())
    .then(async (res) => {
       var response = await res?.data?.filter(c => {return c.numero_socio < 520001 || c.numero_socio > 579999})
      if(response && response?.length > 0){
        const socio = response[0];
        return {
          dni: dni.trim(),
          apellido_nombres: socio.apellido_nombres.trim(),
          direccion: socio.direccion.trim(),
          plan: socio.plan.trim(),
          num_socio: socio.numero_socio
        }
      }else{
        return null
      }
    })
    .catch((error) => {
      console.log(error);
      return null
    });
};

export const userLogin = (data) => {
  if (validateDni(data?.dni)) {
    return axios
      .post("https://api.ciba.com.ar/web-ciba/login", data, { timeout: 10000 })
      .then((response) => {
        if (response?.data?.servicios_suspendidos) {
          if (response?.data?.convenio === "S") {
            return { auth: true, user: response?.data, msg: "" };
          } else {
            return {
              auth: false,
              user: null,
              msg:
                "Servicio Suspendido. Por favor comuniquese al (0341) 420-4820.",
            };
          }
        } else {
          return { auth: true, user: response?.data, msg: "" };
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response) {
          return {
            auth: false,
            user: null,
            msg: "Usuario o clave incorrectos",
          };
        } else {
          return {
            auth: false,
            user: null,
            msg: "Usuario o clave incorrectos",
          };
        }
      });
  } else {
    return {
      auth: false,
      user: null,
      msg: "Ingrese un DNI valido.",
    };
  }
};

export const isNew = (dni) => {
  return axios
    .get("https://prestadores-back.mascota24.com.ar/socios/usuariosapp/" + dni, setHeaders())
    .then((response) => {
      if(response?.data && response?.data?.length > 0){
        return false;
      }else{
        return true;
      }
    })
    .catch((error) => {
      console.log(error);
      return null
    });
};

export const registro = (data) => {

  return axios
    .post("https://prestadores-back.mascota24.com.ar/socios/usuariosapp/alta",
    {
      numero_socio: data.socio.num_socio,
      numero_documento: parseInt(data.dni),
      clave_acceso: data.password,
      email: data.email,
      origen_registro: "app",
      celular: "no requerido",
      codigo_sms: Math.floor(1000 + Math.random() * 9000)
    }
    ,setHeaders())
    .then((response) => {
     return response
    })
    .catch((error) => {
      console.log(error);
      return error
    });
};

export const getUsuario = (dni) => {
  return axios
    .get("https://prestadores-back.mascota24.com.ar/socios/usuariosapp/"+dni, setHeaders())
    .then((response) => {
     return response.data[0]
    })
    .catch((error) => {
      console.log(error);
      return null
    });
};

export const enviarMailRecupero = (data) => {
  return axios
    .post("https://api-flyers.ciba.com.ar/registrados/enviomailmultiuso",
    {
      to: data.email,
      subject: "Recupero de password",
      html: data.html,
      empresa: "CIBA"
    }
    ,setHeaders())
    .then((response) => {
     return true
    })
    .catch((error) => {
      console.log(error);
      return false
    });
};

export const enviarMailRegistro = (data) => {
  return axios
    .post("https://api-flyers.ciba.com.ar/registrados/enviomailmultiuso",
    {
      to: data.email,
      subject: "Confirmación de registro",
      html: `<img src='https://ciba.com.ar/images/login/Ciba-App-Registro-Exitoso.png' alt=''/>`,
      empresa: "CIBA"
    }
    ,setHeaders())
    .then((response) => {
     return true
    })
    .catch((error) => {
      console.log(error);
      return false
    });
};

export const updatePass = (data) => {
  return axios
    .put("https://prestadores-back.mascota24.com.ar/socios/usuariosapp/update",
    {
      numero_documento: parseInt(data.dni),
      clave_acceso: data.password,
      email: data.email
    }
    ,setHeaders())
    .then((response) => {
     return response
    })
    .catch((error) => {
      console.log(error);
      return error
    });
};

const validateDni = (dni) => {
  if (dni.length > 6 && dni.length < 9 && !isNaN(dni)) {
    return true;
  }
  return false;
};

export const logError = (error, errorInfo) => {
      console.log(error, errorInfo)
}